import {yesNoEnum} from '../lib/defaultValueConstants';

export const YES_NO_MAPPING = yesNoEnum;

export const defaultAddress = {
  default: 'card_data.card_address', // adresa implicita
  18406: 'identity_card.address', // "Adresa CI"
  18407: 'residence_address', // "Adresa de resedinta"
  18410: 'correspondence_address', // "Adresa de corespondenta"
};

export const getCurrentStoredAddressLabel = (formValues, addressId) => {
  const {isResidenceAddressSameAsId, isCorrespondenceAddressSameAsId} =
    formValues;

  if (
    (['18410'].includes(addressId) && isCorrespondenceAddressSameAsId) ||
    (['18407'].includes(addressId) && isResidenceAddressSameAsId)
  ) {
    return 'identity_card.address';
  }

  return defaultAddress[addressId] || defaultAddress['default'];
};

export const getAddressDisabledStatus = selectedAddressId =>
  !!defaultAddress[selectedAddressId];
